import { render, staticRenderFns } from "./stockManage.vue?vue&type=template&id=52c8594b&scoped=true&"
import script from "./stockManage.vue?vue&type=script&lang=js&"
export * from "./stockManage.vue?vue&type=script&lang=js&"
import style0 from "./stockManage.vue?vue&type=style&index=0&id=52c8594b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c8594b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c8594b')) {
      api.createRecord('52c8594b', component.options)
    } else {
      api.reload('52c8594b', component.options)
    }
    module.hot.accept("./stockManage.vue?vue&type=template&id=52c8594b&scoped=true&", function () {
      api.rerender('52c8594b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/stockManage.vue"
export default component.exports